/**
 * SDK
 * Export the SDK from window.SDK
 */
const SDK = window.SDK || {};
export default SDK;

// SDK CALLBACK RESPONSE STATUS
export const SDK_STATUS_CALL_STATUS = 'CALL_STATUS';

export const MFChannel = SDK?.MFChannel || {};
